<div class="header">
    <div class="content">
        <h2>{{'results.COVER_ALL_MESSAGES' | transloco}}</h2>
        <p>{{'results.HIGHLIGHT_KEY_POINTS_NOTE' | transloco}}</p>
    </div>
</div>

<div class="container">
    <div class="skills-summary-content">
        <!-- Header -->
        <div class="skills-summary-header">
            <h2>{{'results.MESSAGES_LABEL' | transloco}}</h2>
        </div>

        <!-- Messages -->
         <div class="adherence-messages-container">

            <div *ngFor="let message of messageAdherenceArray">
                <ng-container *ngTemplateOutlet="messageAdherenceFeedback; context: { messageAdherence: message }"></ng-container>
            </div>

         </div>

         <!-- Session ID -->
         <div class="session-id" *ngIf="practiceCallUuid">
            <div class="text" (click)="copyText()" [matMenuTriggerFor]="tooltipMenu">
                {{'results.SESSION_ID' | transloco}} {{ practiceCallUuid }}
            </div>
        </div>
        <mat-menu #tooltipMenu="matMenu" yPosition="above" hasBackdrop="false" class="tooltip-copy-session-id">
            <div>{{'results.SESSION_ID_COPIED' | transloco}}</div>
        </mat-menu>


        <!-- ------------------ -->
        <!-- TEMPLATES TO REUSE -->
        <!-- ------------------ -->

        <!-- Message Adherence Feedback TEMPLATE -->
        <!-- Example: <ng-container *ngTemplateOutlet="messageAdherenceFeedback; context: { messageAdherence: [{messageAdherence}] }"></ng-container> -->
        <ng-template #messageAdherenceFeedback let-messageAdherence="messageAdherence">
            <div class="adherence-messages-content">
                <div class="checkmark-message">
                    <img src="/assets/icons/checkmark-circle-blue.svg" [alt]="'results.CHECKMARK_ICON_ALT' | transloco">
                    <h4>{{'results.MESSAGES_LABEL' | transloco}}</h4>
                </div>
                <div class="message-content">
                    <span
                    class="status-circle"
                    [ngClass]="{
                    'red-fill': messageAdherence.score < 2,
                    'yellow-fill': messageAdherence.score >= 2 && messageAdherence.score < 3,
                    'green-fill': messageAdherence.score >= 3
                    }"
                ></span>
                    <div class="message-status-feedback">
                        <div class="message-status">
                            <h3>{{messageAdherence?.title}}</h3>
                            <p>
                                {{messageAdherence?.message}}
                            </p>
                        </div>
                        <h4>{{'results.WHAT_YOU_DID_WELL' | transloco}}</h4>
                        <div class="message-feedback">
                            <p *ngIf="messageAdherence?.positive">
                                {{messageAdherence?.positive}}
                            </p>
                            <div class="system-message" *ngIf="!messageAdherence?.positive">
                                <p>
                                    <span>{{'results.NO_FACTS_COVERED' | transloco}}</span>
                                </p>
                            </div>
                        </div>
                        <h4>{{'results.WHAT_TO_IMPROVE' | transloco}}</h4>
                        <div class="message-feedback">
                            <p *ngIf="messageAdherence?.negative && messageAdherence?.score < 3">
                                {{messageAdherence?.negative}}
                            </p>
                            <div class="system-message" *ngIf="!messageAdherence?.negative && messageAdherence?.score < 3">
                                <p>
                                    <span>{{'results.NO_SPECIFICS_AVAILABLE' | transloco}}</span>
                                </p>
                            </div>
                            <div class="max-score-message" *ngIf="messageAdherence?.score >= 3">
                                <img src="/assets/icons/confetti-success.svg" [alt]="'results.CONFETTI_ICON_ALT' | transloco">
                                <p>{{'results.ALL_KEY_POINTS_COVERED' | transloco}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>
